import TemplateDiagnosticForm from './TemplateDiagnosticForm';
const meta = {
    title: 'Features/Settings/Integrations/TceTemplateDiagnostic/TemplateDiagnosticForm',
    component: TemplateDiagnosticForm,
    parameters: {
        layout: 'padded'
    },
    args: {
        loading: false,
        onSubmit: () => undefined
    }
};
export default meta;
export const Default = {};
export const Loading = {
    args: { loading: true }
};
